var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeopleIcon = function SvgPeopleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 26,
    viewBox: "0 0 21 26"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EA3556",
    d: "M13.283 2.934a2.925 2.925 0 0 1-2.916 2.935 2.925 2.925 0 0 1-2.915-2.935A2.925 2.925 0 0 1 10.367 0a2.925 2.925 0 0 1 2.916 2.934m.379 13.097H6.896c-.815 0-1.477-1.595-1.477-2.415v-2.768c0-2.052 1.654-3.716 3.694-3.716h2.333c2.04 0 3.693 1.664 3.693 3.716v2.768c0 .82-.661 2.415-1.477 2.415"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AA2C4",
    d: "M7.864 7.056a2.925 2.925 0 0 1-2.916 2.935 2.925 2.925 0 0 1-2.916-2.935 2.925 2.925 0 0 1 2.916-2.934 2.925 2.925 0 0 1 2.916 2.934"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93278F",
    d: "M18.703 7.056a2.925 2.925 0 0 1-2.917 2.935 2.925 2.925 0 0 1-2.915-2.935 2.925 2.925 0 0 1 2.915-2.934 2.925 2.925 0 0 1 2.917 2.934"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AA2C4",
    d: "M8.243 20.517H1.477C.661 20.517 0 18.922 0 18.101v-2.767c0-2.052 1.654-3.716 3.693-3.716h2.334c2.04 0 3.693 1.664 3.693 3.716v2.767c0 .821-.662 2.416-1.477 2.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#93278F",
    d: "M19.081 20.517h-6.765c-.816 0-1.477-1.595-1.477-2.416v-2.767c0-2.052 1.653-3.716 3.693-3.716h2.333c2.04 0 3.693 1.664 3.693 3.716v2.767c0 .821-.661 2.416-1.477 2.416"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBD15D",
    d: "M13.283 12.553a2.925 2.925 0 0 1-2.916 2.934 2.925 2.925 0 0 1-2.915-2.934 2.925 2.925 0 0 1 2.915-2.935 2.925 2.925 0 0 1 2.916 2.935m.379 13.097H6.896c-.815 0-1.477-1.596-1.477-2.416v-2.767c0-2.053 1.654-3.716 3.694-3.716h2.333c2.04 0 3.693 1.663 3.693 3.716v2.767c0 .82-.661 2.415-1.477 2.415z"
  }))));
};
export default SvgPeopleIcon;